export const gotDateUsers=(dateUsers)=>({
    type:'GOT_DATE_USERS',
    dateUsers
});

export const GOT_USER_SESSIONS = 'GOT_USER_SESSIONS';

export const gotUserSessions=(data)=>({
    type: GOT_USER_SESSIONS,
    userSessions :data.records,
    version : data.version === '0' ? data.records[0].events[0].appVersion : data.version,
    userInfo : data.info
});

export const viewDetails=(event)=>({
    type:'VIEW_EVENT',
    event
});

export const hideDetails=()=>({
    type:'HIDE_EVENT'
});

export const gotMetrika=(metrika)=>({
    type:'GOT_METRIKA',
    metrika
});

export const gotUsage=(usage)=>({
    type:'GOT_USAGE',
    usage
});

export const gotExceptions=(exceptions)=>({
    type:'GOT_EXCEPTIONS',
    exceptions: exceptions.exceptions,
    isLastPage: exceptions.isLastPage
});